// Remote session access mode shared by the Web/Desktop controller and host.
// Older clients omit the field, so the compatibility default is control.

export type SessionAccessMode = 'control' | 'view';

export function normalizeSessionAccessMode(value: unknown): SessionAccessMode {
  return value === 'view' ? 'view' : 'control';
}

export function isViewOnlySession(value: unknown): boolean {
  return normalizeSessionAccessMode(value) === 'view';
}
